import React from 'react';

import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { selectHelpMode, selectStoryOptions } from 'components/app/_mediator/app-data.slice';
import { setSelectedStory } from 'components/app/projects/_mediator/projects.slice';
import { Tooltip } from 'components/UI/tooltip/tooltip';
import { Select } from 'components/UI/select/select';

interface Props {
  className?: string;
  disableStoriesWithoutFinalcuts?: boolean;
}

export const StorySelector = ({ className, disableStoriesWithoutFinalcuts }: Props) => {
  const { selectedStory } = useAppSelector((state) => state.projects);
  const storyOptions = useAppSelector(selectStoryOptions);
  const helpMode = useAppSelector(selectHelpMode);
  const dispatch = useAppDispatch();

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setSelectedStory(Number(event.target.value)));
  };

  return (
    <Tooltip tip="Selected story" showTooltip={helpMode} position="bottom">
      <Select
        options={storyOptions}
        value={selectedStory ?? undefined}
        className={className ?? undefined}
        onChange={handleSelect}
        disabledOptions={disableStoriesWithoutFinalcuts}
        colored
      />
    </Tooltip>
  );
};
